import { combineReducers } from "@reduxjs/toolkit";
import searchStoreReducer from "features/searchStore/saga/searchStoreSlice";
import homepageReducer from "features/homepage/saga/homepageSlice";


export const reducer = combineReducers({
    homepage: homepageReducer,
    searchStore: searchStoreReducer,
})